// TODO:  确认后端 全仓盘点 字段
export const FULL_STOCK_COUNT_ROUTE_NAME = 'inventoryManagement.fullStockCount';
export const CYCLE_COUNT_ROUTE_NAME = 'inventoryManagement.cycleCount';
export const DASHBOARD_FULL_STOCK_COUNT_ROUTE_NAME = 'dashboard.fullStockCount';
export const DASHBOARD_CYCLE_COUNT_ROUTE_NAME = 'dashboard.locationCycleCount';
export const ASN_QUOTA_CONFIG_ROUTE_NAME =
  'ruleCenter.quotaConfig.asnQuotaConfig';

/**
 * Prepack 子树的根路由名
 *
 * 侧边栏的按仓开关与路由守卫都认它, 两处必须是同一个值: 一处放行一处拦截的话,
 * 表现是菜单里没有入口但地址栏进得去
 */
export const PREPACK_ROUTE_NAME = 'salesOutbound.prepack';

export const cycleCountMainMenuRouteName = [
  CYCLE_COUNT_ROUTE_NAME,
  FULL_STOCK_COUNT_ROUTE_NAME,
];

export const dashboardCycleCountMainMenuRouteName = [
  DASHBOARD_CYCLE_COUNT_ROUTE_NAME,
  DASHBOARD_FULL_STOCK_COUNT_ROUTE_NAME,
];
